var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{class:{ 'm-menu-divider': _vm.divider }},[(!_vm.divider)?_c('a',{class:{ 'm-sub-menu': _vm.submenu }},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }